import script from "./AddHomeLoginPrompt.vue?vue&type=script&setup=true&lang=js"
export * from "./AddHomeLoginPrompt.vue?vue&type=script&setup=true&lang=js"

import "./AddHomeLoginPrompt.vue?vue&type=style&index=0&id=71bc885b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71bc885b"]])

export default __exports__